module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navmenu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/userProfile",
      "id": "menu-open-request"
    }
  }, [_vm._v("Minhas Requisições")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/openRequest",
      "id": "menu-open-request"
    }
  }, [_vm._v("Abrir Requisição")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser && _vm.adminUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/management",
      "id": "menu-admin"
    }
  }, [_vm._v("Administração")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(!_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-log-in"
  }), _vm._v(" Entrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "id": "welcome-menu-item",
      "to": "/userProfile",
      "title": "Clique ver seu perfil"
    }
  }, [_vm._v("Bem-vindo, " + _vm._s(_vm.loggedUser.get('name')) + " "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.numberOfLinkedRequests))])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login?ex=1",
      "id": "btn-logout"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off"
  }), _vm._v(" Sair")])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navmenu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Trocar Modo de Navegação")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/ifpelogo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75eb0f36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 1460
// module chunks = 1